//---------------------------------
// get substring after find string
//---------------------------------
export default function getSubstringAfterFindString(whole_string, find_string) {
  // console.log('-----------------------')
  // console.log('IN getSubstringAfterFindString whole_string:', whole_string, ' find_string:', find_string)
  //-------------------
  // check valid parms
  //-------------------
  if (typeof whole_string !== 'string' || typeof find_string !== 'string') {
    return ''
  }
  //---------------
  // specify regex
  //---------------
  const regex = new RegExp(`^${find_string}(.+)$`)
  //---------------------------------
  // get substring after find string
  //---------------------------------
  let sub_string = whole_string.match(regex)
  // console.log('Substring match:', sub_string)
  //----------------------------------
  // return substring or whole string
  //----------------------------------
  return sub_string ? sub_string[1] : whole_string
}
